export default __webpack_public_path__ + "static/media/image.ea8b5003.png";